<template>
  <div id="loading">
    <div class="modal-body">
      <div class="loading__login" v-if="!ready">
        <div style="position:relative; text-align:center;">
          <i class="custom-loading-color fa fa-spinner fa-spin fa-5x fa-fw"></i>          
          <!--div style="margin-top: 3vh"><span style="color: white;"><h3 style="font-weight: 400;">Cargando...</h3></span></-div !-->
        </div>                
      </div>

      <div class="info text-center" v-else>
       <h4 class="text-uppercase">
         <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          {{info.msg}}
       </h4>
        <h5>
          {{info.subMsg}}
        </h5>
        <button id="info-button" class="btn btn-danger" data-dismiss="modal">Cerrar</button>
      </div>
    </div>
    <button id="dismiss-button" data-dismiss="modal" ></button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ready: false,
      theInfo: {}
    }
  },
  props: ['info'],
  mounted() {
    let modal = document.querySelector('#loading-modal-modal')
    if(modal !== null) {
      modal.removeAttribute('tabindex')
      modal.setAttribute('data-backdrop', 'static')
    }

    setInterval(() => {
      if (this.info.ready !== undefined) {
        this.ready = this.info.ready
        clearInterval()
      }
    }, 500)
  },
  watch: {
   info() {
     this.ready = this.info.ready;
   }
  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';

#loading-modal-modal {
    background-color: rgba(255, 255, 255, 0.8) !important;
}

#loading {
  position: relative;    
  .loading__login {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .fa-spinner {
      color: var(--loading-color);
    }
    h4 {
      color: $amarilloO;
      position: absolute;
      left: -30px;
    }
  }
  #dismiss-button {
    position: absolute;
    z-index: -999999;
    visibility: hidden;
  }
  .info {
    position: absolute;
    background-color: white;
    width: 100%;
    top: 50%;
    left: 50%;
    color: var(--btn-default-bg);
    transform: translate(-50%, -50%);
    h4 {
      background-color:$rojoMapa;
      margin: 0;
      padding: 25px;
      color: white;
    }
    h5 {
      padding: 50px 0;
      color: black;
    }
    #info-button {
      margin-bottom: 25px;
    }
  }
}

.modal-body {
  height: 55vh;
  background-color: transparent;
  @include celphone {
    height: 38vh;
  }
}
</style>



// WEBPACK FOOTER //
// LoginModal.vue?9c7616ee